<template>
  <div>
    <Head title="Work Order - mattress production" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/work-orders/mattress-delumping/productions">
        Work Orders
      </Link>
      <span class="text-orange-400 font-medium">/</span>{{ workOrder.WO_number }}/Production
    </h1>
    <div 
      v-show="workOrder.status == 1"
      class="max-w-full bg-white rounded-md shadow overflow-hidden mb-3"
    >
      <form @submit.prevent="store">
        <div class="pb-2 pr-6 w-full lg:w-full mb-8">
          <div
            v-for="(work_order_sku, index) in form.work_order_skus"
            :key="index"
            class="flex flex-wrap -mb-16 -mr-6 p-8"
          >
            <div class="pb-2 pr-6 w-full lg:w-8/12">
              <text-input
                class="w-full lg:w-full read-only:bg-gray-100"
                :placeholder="`${ work_order_sku.description }`"
                disabled="disabled"
              />
              <text-input
                class="hidden"
                v-model="work_order_sku.sku_id"
              />
              <text-input
                class="hidden"
                v-model="work_order_sku.id"
              />
            </div>
            <div class="pb-2 pr-6 w-full lg:w-4/12">
              <text-input
                class="w-full lg:w-full"
                v-model="work_order_sku.quantity"
                :error="isValidationErrors(`work_order_skus.${index}.quantity`)"
                placeholder="Quantity"
              />
              <span
                v-if="isValidationErrors(`work_order_skus.${index}.quantity`)"
                class="mt-3"
              >
                <span class="form-error">{{ showValidationErrors(`work_order_skus.${index}.quantity`) }}</span>
              </span>
            </div>
          </div>
        </div>
        <div
          class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100"
        >
          <loading-button :loading="form.processing" class="btn-orange" type="submit">
            Add
          </loading-button>
        </div>
      </form>
    </div>
    <hr/>
    <ul class="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4" id="tabs-tabFill"
      role="tablist">
      <li class="nav-item flex-auto text-center" role="presentation">
        <a href="#tabs-profileFill" class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
          active
        " id="tabs-profile-tabFill" data-bs-toggle="pill" data-bs-target="#tabs-profileFill" role="tab"
          aria-controls="tabs-profileFill" aria-selected="false">Scans</a>
      </li>
      <li class="nav-item flex-auto text-center" role="presentation">
        <a href="#tabs-summaryFill" class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
        " id="tabs-summary-tabFill" data-bs-toggle="pill" data-bs-target="#tabs-summaryFill" role="tab"
          aria-controls="tabs-summaryFill" aria-selected="false">Summaries</a>
      </li>
    </ul>
    <div class="tab-content" id="tabs-tabContentFill">
      <div class="tab-pane fade show active" id="tabs-profileFill" role="tabpanel" aria-labelledby="tabs-profile-tabFill">
        <div class="flex items-center justify-between mb-6">
          <a
            v-if="woodworks.data.length > 0"
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            :href="`/work-orders/${workOrder.id}/mattress-delumping/productions/scans/download`"
            download
            target="__blank"
          >
            <span>Download</span>
          </a>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Date</th>
              <th class="pb-3 pt-3 px-3">WO Number</th>
              <th class="pb-3 pt-3 px-3">Part Number</th>
              <th class="pb-3 pt-3 px-3">Part Description</th>
              <th class="pb-3 pt-3 px-3 text-center">Quantity</th>
              <th class="pb-3 pt-3 px-3">UoM</th>
              <th class="pb-3 pt-3 px-3">Created By</th>
            </tr>
            <tr v-for="woodwork in woodworks.data" :key="woodwork.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <span class="flex items-center px-3 py-2 focus:text-orange-500">
                  {{ woodwork.date }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2" tabindex="-1">
                  {{ woodwork.wo_number }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2" tabindex="-1">
                  {{ woodwork.part_no }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2" tabindex="-1">
                  {{ woodwork.description }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2 text-center" tabindex="-1">
                  {{ woodwork.quantity }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2 text-center" tabindex="-1">
                  {{ woodwork.measure }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2" tabindex="-1">
                  {{ woodwork.user }}
                </span>
              </td>
            </tr>
            <tr v-if="woodworks.data.length === 0">
              <td class="px-6 py-4 border-t" colspan="8">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="woodworks.links" />
      </div>
      <div class="tab-pane fade" id="tabs-summaryFill" role="tabpanel" aria-labelledby="tabs-summary-tabFill">
        <div class="flex items-center justify-between mb-6">
          <a
            v-if="issuace_summaries.data.length > 0"
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            :href="`/work-orders/${workOrder.id}/mattress-delumping/productions/summaries/download`"
            download
            target="__blank"
          >
            <span>Download</span>
          </a>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Part Number</th>
              <th class="pb-3 pt-3 px-3">Part Description</th>
              <th class="pb-3 pt-3 px-3">Quantity</th>
              <th class="pb-3 pt-3 px-3">UoM</th>
            </tr>
            <tr
              v-for="inventory in issuace_summaries.data"
              :key="inventory.id"
              class="hover:bg-orange-100 focus-within:bg-gray-100"
            >
              <td class="border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ inventory.sku_name }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ inventory.description }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ inventory.quantity }}
                </span>
              </td>
              <td class="w-px border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500 text-right">
                  {{ inventory.unit_of_measure }}
                </span>
              </td>
            </tr>
            <tr v-if="issuace_summaries.data.length === 0">
              <td class="px-6 py-4 border-t" colspan="8">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="issuace_summaries.links" />
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Pagination from '@/Shared/Pagination'
import DateRange from '@/Shared/DateRange'

export default {
  components: {
    Head,
    Icon,
    Link,
    DateRange,
    TextInput,
    SelectInput,
    LoadingButton,
    Pagination,
  },
  layout: Layout,
  remember: 'form',
  props: {
    filters: Object,
    workOrder: Object,
    woodworks: Object,
    work_order_skus: Object,
    issuace_summaries: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        work_order_skus: this.work_order_skus,
      }),
      search: {
        dateRange: this.filters.dateRange
      },
      summary: {
        dateRange: this.filters.dateRange
      }
    }
  },
  computed: {
    role() {
      return this.$inertia.page.props.auth.user.role
    },
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(`/work-orders/${this.workOrder.id}/mattress-delumping/productions/create`, pickBy(this.search), { preserveState: true })
      }, 150),
    },
    summary: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(`/work-orders/${this.workOrder.id}/mattress-delumping/productions/create`, pickBy(this.summary), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    isValidationErrors(value) {
      if (this.form.errors) {
        const error = this.form.errors[value] || '';
        return !!error;
      }
      return false;
    },
    showValidationErrors(value) {
      if (this.form.errors) {
        const error = this.form.errors[value] || '';
        return error || '';
      }
      return '';
    },
    resets() {
      this.summary = mapValues(this.summary, () => null)
    },
    store() {
      this.form.post(`/work-orders/${this.workOrder.id}/mattress-delumping/productions/store`, {
        onSuccess: () => {
          this.form.reset(
            'work_order_skus',
          )
        }
      })
    },
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>